import type { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger" | "ghost";
  size?: "sm" | "md";
}

const base =
  "inline-flex min-h-11 items-center justify-center font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-barrel/80 disabled:opacity-50 disabled:cursor-not-allowed";

const variants = {
  primary: "bg-barrel text-white hover:bg-garnet",
  secondary: "border border-barrel text-barrel hover:bg-barrel/5",
  danger: "bg-red-600 text-white hover:bg-red-700",
  ghost: "text-terroir hover:text-noir hover:bg-noir/5",
};

const sizeStyles = {
  sm: "text-sm px-3 py-2.5",
  md: "text-sm px-4 py-3",
};

export function Button({
  variant = "primary",
  size = "md",
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      className={`${base} ${variants[variant]} ${sizeStyles[size]} ${className}`}
      {...props}
    />
  );
}
